export enum FamilyResidentAccess {
  Activities = 'activities',
  Care = 'care',
  CareNotes = 'careNotes',
  CareSummary = 'careSummary',
  Chat = 'chat',
  Concierge = 'concierge',
  ConciergeEvents = 'conciergeEvents',
  DailyCare = 'dailyCare',
  DailyPlan = 'dailyPlan',
  CarePlan = 'carePlan',
  InstantCalls = 'instantCalls',
  Lifestyle = 'lifestyle',
  LifestyleEvents = 'lifestyleEvents',
  Noticeboard = 'noticeboard',
  ScheduledCalls = 'scheduledCalls'
}